import { useState, useEffect, useRef  } from 'react'
import PropTypes from 'prop-types';
import { CSVLink, CSVDownload } from "react-csv"  // requires npm install --save prop-types !

const CsvExport = props => {

  //console.log('props: ',props)
  const {
    value,
    objectId,
    csvColumns,
    postType,
  } = props

  const today = new Date();
  const {ajax, ajaxConfig} = window.Tangible
  const [ loading, setLoading ] = useState(false )

  // CSV data filters
  const dateFrom = tangibleFields.render({
    type: 'date-picker',
    name: 'tgbl_csv_data_date_from',
    value: '',
    label: 'From',
  })

  const dateTo = tangibleFields.render({
    type: 'date-picker',
    name: 'tgbl_csv_data_date_to',
    value: '',
    label: 'To',
  })

  const associatedCourse = tangibleFields.render({
    type: 'combo-box',
    name: 'tgbl_csv_data_associated_course',
    label: 'Associated Course',
    multiple: true,
    isAsync: true,
    ajaxAction: 'tgbl_get_courses',
    asyncArgs:{
      post_type: 'sfwd-courses'
    }
  })

  const user = tangibleFields.render({
    type: 'combo-box',
    name: 'tgbl_csv_data_user',
    label: 'User',
    multiple: true,
    isAsync: true,
    ajaxAction: 'tgbl_get_users',
    asyncArgs:{
      content_type: 'user'
    }
  })

  const csvLinkEl = useRef(null)
  const [ csvData, setCsvData ] = useState([] )

  const dataFiltersKeys =[
    'tgbl_csv_data_date_from',
    'tgbl_csv_data_date_to',
    'tgbl_csv_data_associated_course',
    'tgbl_csv_data_user',
  ]
  let columnsKeys = []
  let columnsHeaders = []
  const columns = JSON.parse(csvColumns)

  columns.map((column, idx) => {
    columnsKeys.push(column['key'])
    columnsHeaders.push({label: column['label'], key: column['key']})
  })

  const [ headers, setHeaders ] = useState(columnsHeaders)
  const [ dataFilters, setDataFilters ] = useState([])

  const removeItem = (itemToRemove, type) => {
    const array = type === 'headers' ? headers : type === 'filters' ? dataFilters : []

    // filter only the those that don't have the key we want to remove
    const updatedArray = array.filter((item) => {
      return item.key !== itemToRemove
    })
    if(type === 'headers') {
      setHeaders(updatedArray)
    } else if(type === 'filters'){
      setDataFilters(updatedArray)
    }
  }

  const addItem = (itemToAdd, type) => {
    const array = type === 'headers' ? headers : type === 'filters' ? dataFilters : []

    const removedHeaderArray = array.filter((item) => {
      return item.key !== itemToAdd.key
    })
    const updatedArray = [...removedHeaderArray, itemToAdd]

    if(type === 'headers') {
      const reindexedArray = []
      columnsKeys.forEach((c_key, index) => {
        const found = updatedArray.find(({ key }) => key === c_key)
        if(found) reindexedArray.push(found)
      })
      setHeaders(reindexedArray)
    } else if(type === 'filters'){
      setDataFilters(updatedArray)
    }
  }

  tangibleFields.event('valueChange', field => {

    columnsKeys.forEach((c_key, index) => {
      if ( field.name === c_key ){
        if (field.value === 'on') {
          addItem({label: field.props['label'], key: field.props['name']}, 'headers')
        } else{
          removeItem(field.props['name'], 'headers')
        }
      }
    })

    dataFiltersKeys.forEach((df_key, index) => {
      let filters = []
      if ( field.name === df_key ){
        if (field.value) {
          addItem({value: field.value, key: field.props['name']}, 'filters')
        } else{
          removeItem(field.props['name'], 'filters')
        }
      }
    })
  })

  //console.log( dataFilters )
  //console.log( headers)

  const getCsvData = () => {

    const data = {
      post_id: objectId,
      filters: dataFilters,
      columns_keys: columnsKeys,
      post_type: postType,
      columns_headers: headers,
    }

    ajax('tgbl_earned_accreditations_csv_export_ajax', data)
      .then((res) => {
        console.log(res)
        if(res) {
          /*
            Process data from ajax if needed
            For now we just pass response
          */
          setCsvData(res)

          // Trigger CSV download
          setTimeout(() => {
            csvLinkEl.current.link.click()
          })
        }
      }).catch(error => {
      console.error('PE Ajax error', error)
    }).finally(() => {
      //setAjaxRetryDone(true)
    })
  }

  return (
    <div className="tgbl-csv-export">
        <div className="csv-export-data">
        { dateFrom }
        { dateTo }
        { associatedCourse }
        { user }
        </div>
        <div className="csv-export-filters">
          {
            columnsHeaders.map((ck, idx) => {
              return tangibleFields.render({
                type: 'switch',
                name: ck['key'],
                value: 'on',
                label: ck['label'],
              })
            })
          }
        </div>
        <div className="csv-export-button">
          <a
            type="button"
            className={"button button-primary button-large"}
            onClick={getCsvData}>
            Export to CSV
          </a>
          <CSVLink
            data={csvData}
            headers={headers}
            filename={'Earned Accreditations.csv'}
            ref={csvLinkEl}
          >
          </CSVLink>
      </div>
    </div>
  )
}

export { CsvExport }
